import AttendanceSerializer from './base';

export default class AlertLog extends AttendanceSerializer {}
